import { AlertColor } from "@mui/material";

export interface NotificationOptions {
  message: string;
  level: AlertColor;
  title?: string;
  position?: "tr" | "tl" | "tc" | "br" | "bl" | "bc";
  autoDismiss?: number;
  dismissible?: boolean;
}

export interface NotificationsState {
  notify: (notification: NotificationOptions) => void;
}

export const defaultNotificationOptions: Partial<NotificationOptions> = {
  position: "tr",
  autoDismiss: 5,
  dismissible: true,
}; 